export default class enviroment {
  APIUrl = 'https://mathcastro.com.br/';
}
